const baseUrl = '/api/customer/user'

export default {
    follow: (userId) => {
        return axios.post(`${baseUrl}/follow/${userId}`)
    },

    unfollow: (userId) => {
        return axios.delete(`${baseUrl}/follow/${userId}`)
    },

    followers: (userId) => {
        return axios.get(`${baseUrl}/followers/${userId || ''}`)
    },

    following: () => {
        return axios.get(`${baseUrl}/following`)
    },
}
